import { useMemo } from "react";
import { SelectInputProps } from "../../../components/common/Inputs/SelectInput";
import { useDistributorTypes } from "./useDistributorTypes";

export const useDistributorTypesOptions = () => {
  const { distributorTypes, isLoading } = useDistributorTypes({
    filter: { name: "" },
    pagination: {
      page: 1,
      pageSize: 15,
    },
  });

  const distributorTypesOptions: SelectInputProps["options"] = useMemo(() => {
    if (isLoading) return [];
    return distributorTypes.map((d) => ({ label: d.name, value: d._id }));
  }, [distributorTypes, isLoading]);

  return {
    distributorTypesOptions,
    isLoading,
  };
};
